import {
    GET_EVENT_BUSINESS_AREA_API_KEYS_SUCCESS,
    GET_EVENT_BUSINESS_AREA_API_KEYS_FAILURE
} from "./actions";

const initialState = {
    getEventBusinessAreaApiKeysResult: {
        success: true
    },
    apiKeysResult: {
        Items: []
    }
};

export default (state = initialState, action) => {
    let apiKeysResult = {
        Items: []
    };
    switch (action.type) {
        case GET_EVENT_BUSINESS_AREA_API_KEYS_SUCCESS:
            apiKeysResult = action.payload.apiKeysResult;
            return { ...state, getEventBusinessAreaApiKeysResult: { success: true }, apiKeysResult };
        case GET_EVENT_BUSINESS_AREA_API_KEYS_FAILURE:
            return {
                ...state,
                getEventBusinessAreaApiKeysResult: { success: false, ...action.payload.error },
                apiKeysResult: {
                    Items: []
                }
            };
        default:
            return state;
    }
};
